import { defineComponent, Types } from "bitecs";

export const SoundComponent = defineComponent({
    soundLocation: [Types.f32, 3],
    autoplay: Types.i8,
    loop: Types.i8,
    volume: Types.f32,
    mute: Types.i8,
    rate: Types.f32,
    dirty: Types.i8,
});
